/**
 * Slová o variante, ktorú aktualizácia z exportu mení (KOLO 218).
 *
 * Náhľad písal „Dielce, ktoré v exporte sú a vo výpočte ešte nie" aj pri
 * výrobe — od KOLA 208 import s AA/Z zakladá výrobnú variantu, takže
 * „výpočet" bol vo väčšine aktualizácií nesprávne slovo. Server pošle
 * `co` (`casti_zakazky.druh_varianty`), tu sú z neho tvary do viet.
 */
export type DruhVarianty = "výpočet" | "výroba" | "časť";

function druh(co: string | null | undefined): DruhVarianty {
  return co === "výroba" || co === "časť" ? co : "výpočet";
}

/** „vo výpočte" / „vo výrobe" / „v časti". */
export function vDruhu(co: string | null | undefined): string {
  return { výpočet: "vo výpočte", výroba: "vo výrobe", časť: "v časti" }[
    druh(co)
  ];
}

/** „Výpočet aktualizovaný" / „Výroba aktualizovaná" / „Časť aktualizovaná". */
export function druhAktualizovany(co: string | null | undefined): string {
  return {
    výpočet: "Výpočet aktualizovaný",
    výroba: "Výroba aktualizovaná",
    časť: "Časť aktualizovaná",
  }[druh(co)];
}
